import { useEffect, useState } from 'react';
import { AgGridReact } from 'ag-grid-react';

import { useVisualizationOptionsContext } from '../../../../../context';

import { SYNTHETIC_GLOBAL_SEARCH_COL } from './make-columns';

type UseSearchProps = {
    activeGroup?: string;
    grid: AgGridReact | null;
};

const useSearch = ({ activeGroup, grid }: UseSearchProps) => {
    const [search, setSearch] = useState<string>('');

    const {
        features: { tableSearch },
    } = useVisualizationOptionsContext();
    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!tableSearch) return;

        const query = e.target.value;
        const trimmedQuery = query.toLowerCase();

        grid?.api.setFilterModel({
            [SYNTHETIC_GLOBAL_SEARCH_COL.colId]: {
                filterType: 'text',
                type: 'contains',
                filter: trimmedQuery,
            },
        });

        setSearch(trimmedQuery);
    };

    useEffect(() => {
        // reset search when active group changes
        setSearch('');
    }, [activeGroup]);

    return {
        search,
        handleSearch,
    };
};

export { useSearch };
